export const ICONS = {
  WARN: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUBAMAAAB/pwA+AAAAIVBMVEUAAADXLAzXLA7XKwzXMBDXMAjWLA3XLQ7XLQ3YLA3XLA0HG5sRAAAACnRSTlMAgH9wICDv39/vdFxkWAAAAGdJREFUCNc9y7sNgDAMhOELJRUdEhV1BqBgBNagYwRKJuEhJPCU2BebK6Jfn2LYhg2+SqT3zCLnj8qBZOI9GRP3WpnIVM6RF9bIF4uUM3kwiu9AimyAjh8UgWRJJBMLE8lEZyLXzvZ+D25F9Zvfe7AAAAAASUVORK5CYII=',
};
